import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Answer } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface AnswersState {
  answers: Answer[];
}

// Define the initial state using that type
const initialState: AnswersState = {
  answers: [],
};

export const answersSlice = createSlice({
  name: "answers",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setGlobalAnswers: (state, action: PayloadAction<Answer[]>) => {
      state.answers = action.payload;
    },
  },
});

export const { setGlobalAnswers } = answersSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAnswers = (state: RootState) => state.answers;
export default answersSlice.reducer;
